import React from 'react';
import { CheckCircle, Target, UsersThree } from '@phosphor-icons/react';
import PublicSiteLayout from '../components/PublicSiteLayout';

export default function PublicAboutPage() {
  return (
    <PublicSiteLayout>
      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-10 items-start">
          <div className="bg-white border border-[#E8E6E1] rounded-[30px] p-8 shadow-sm">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#7A766E]">About Us</p>
            <h1 className="mt-4 text-4xl font-extrabold tracking-tight" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Built to make personal finance easier to read and act on.
            </h1>
            <p className="mt-5 text-[#5C5A56] leading-8">
              Spell FinX brings together daily transactions, accounts, investments, payments, liabilities, reminders, and reporting into one clear workflow. The goal is simple: make financial data less fragmented and more useful.
            </p>
          </div>

          <div className="space-y-5">
            <AboutCard
              icon={Target}
              title="Purpose"
              description="Reduce the friction of tracking multiple money activities across separate notebooks, spreadsheets, and apps."
            />
            <AboutCard
              icon={UsersThree}
              title="Who It Helps"
              description="Anyone managing income, expenses, EMI, investments, loans, accounts, and reporting for personal or household use."
            />
            <AboutCard
              icon={CheckCircle}
              title="What It Emphasizes"
              description="Clear summaries, practical reminders, and structured reports instead of decorative dashboards that hide important numbers."
            />
          </div>
        </div>
      </section>
    </PublicSiteLayout>
  );
}

function AboutCard({ icon: Icon, title, description }) {
  return (
    <div className="bg-white border border-[#E8E6E1] rounded-3xl p-6 shadow-sm">
      <div className="w-12 h-12 rounded-2xl bg-[#D98324]/10 flex items-center justify-center">
        <Icon size={22} weight="fill" className="text-[#D98324]" />
      </div>
      <h2 className="mt-4 text-xl font-bold text-[#1C1B1A]">{title}</h2>
      <p className="mt-2 text-sm leading-7 text-[#5C5A56]">{description}</p>
    </div>
  );
}
